// extracted by mini-css-extract-plugin
module.exports = {"prose":"Prose_prose__aiXVf"};